import styled from "styled-components";

const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default Flex;
